import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./sort-by-select.scss";

import check from "../../../../assets/icons/Icon - Checkmark.svg";
import downArrow from "../../../../assets/icons/Icon - Chevron - Down.svg";

import * as dashboardDynamicFieldsUtil from '../../dynamic-fields/dashboard-dynamic-fields-util';

const Toggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="select-toggle"
  >
    {children}
  </a>
));

const SortBySelect = ({ value, handleSelect, options, type, isMagnified }) => {
  const [show, setShow] = useState(false);

  const showCheckmark = (option) => {
    if (
      value === option ||
      (option === 'Custom' &&
        ![
          'Last 7 Days',
          'Last Month',
          'Last 3 Months',
          'Last 6 Months',
          'Last 12 Months',
          ...dashboardDynamicFieldsUtil.SORT_TYPES_ARRAY,
        ].includes(value))
    ) {
      return <img src={check}></img>;
    }
  };

  return (
    <Dropdown className="dashboard-widget-select" onBlur={() => setShow(false)}>
      <Dropdown.Toggle as={Toggle}>
        <div
          className={`dropdown-title${
            !isMagnified && value.length > 20 ? "-small" : "-big"
          }`}
          onClick={() => setShow(!show)}
        >
          {value}
          <div className="arrow-padding">
            <img src={downArrow} className={`${show ? "arrow-up" : ""}`}></img>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className={`custom-select custom-select-width-${type}`}>
          {options.map((option, index) => (
            <Dropdown.Item
              eventKey={option}
              onSelect={handleSelect}
              className="custom-select-option custom-select-option-height-1 option-padding"
              key={option}
            >
              <span
                className={`custom-select-text ${
                  value === option ? "selected-text" : "unselected-text"
                } flex-grow-1`}
              >
                {option}
              </span>
              {showCheckmark(option)}
              <hr
                className={`custom-hr ${
                  index === options.length - 1 ? "border-0" : ""
                }`}
              />
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SortBySelect;
